import { get, post } from '../api/client'

const bytesToBase64 = (bytes: Uint8Array) => {
  let binary = ''
  for (const byte of bytes) binary += String.fromCharCode(byte)
  return btoa(binary)
}

export async function ensureVerifiedSolana(address: string, provider: any) {
  if (!address || !provider?.signMessage) throw new Error('Connect a Solana wallet that supports message signing')
  const session: any = await get('/api/v1/auth/session').catch(() => null)
  if (session?.wallets?.some?.((wallet: any) => wallet.namespace === 'solana' && String(wallet.address).toLowerCase() === address.toLowerCase())) return session
  const challenge: any = await post('/api/v1/auth/challenge', { namespace: 'solana', address })
  const signed = await provider.signMessage(new TextEncoder().encode(challenge.message))
  const raw = signed?.signature || signed
  await post('/api/v1/auth/verify/solana', { challenge_id: challenge.challenge_id, address, signature: typeof raw === 'string' ? raw : bytesToBase64(raw) })
  window.dispatchEvent(new Event('rose:session-changed'))
  return get('/api/v1/auth/session')
}

export async function ensureVerifiedEvm(address: string, provider: any) {
  if (!address || !provider?.request) throw new Error('Connect an EVM wallet')
  const session: any = await get('/api/v1/auth/session').catch(() => null)
  if (session?.wallets?.some?.((wallet: any) => wallet.namespace === 'eip155' && String(wallet.address).toLowerCase() === address.toLowerCase())) return session
  const challenge: any = await post('/api/v1/auth/challenge', { namespace: 'eip155', address })
  let signature
  try { signature = await provider.request({ method: 'personal_sign', params: [challenge.message, address] }) }
  catch { signature = await provider.request({ method: 'eth_sign', params: [address, challenge.message] }) }
  await post('/api/v1/auth/verify/eip155', { challenge_id: challenge.challenge_id, address, signature })
  window.dispatchEvent(new Event('rose:session-changed'))
  return get('/api/v1/auth/session')
}
